export default "__VITE_ASSET__DfdgVJGK__"